<template>
    <el-dialog title="详情" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false" width="80%">
        <el-form size="small" :model="form">
           
            <el-form-item label="头像：" prop="avatarUrl"  :label-width="formLabelWidth">
            <div class="draggable-list">
                <div v-if="form.avatarUrl">
                    <div class="item">
                        <img v-img-url="form.avatarUrl" alt="file_path"/>
                        </div>
                    </div>
            
            </div>
            </el-form-item>

           
           
            <el-form-item label="客户姓名" :label-width="formLabelWidth">
                {{ form.nickName }}
            </el-form-item>

            <el-form-item label="个签" :label-width="formLabelWidth">
                {{ form.person_dy }}
            </el-form-item>

            <el-form-item label="微信账户" :label-width="formLabelWidth">
                {{ form.wx_account }}
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                {{ form.mobile }}
            </el-form-item>


            <el-form-item label="所在区域" :label-width="formLabelWidth" >
              <div style="display: flex;">
                <el-select @change="provinceChange" :disabled="true" v-model="form.province_name" filterable  placeholder="请选择省份">
                    <el-option
                            v-for="item in province_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="cityChange" :disabled="true" v-model="form.city_name" filterable placeholder="请选择城市" 
              >
                    <el-option
                            v-for="item in city_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="regionChange" :disabled="true" v-model="form.region_name" filterable placeholder="请选择区域" 
              >
                    <el-option
                            v-for="item in region_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
              </div>
            </el-form-item>



            
            <div class="common-form mt16" >发布的动态</div>
                <el-table
                  :data="biji"
                  border
                  style="width: 100%"
                >
                <el-table-column prop="name" label="动态名称" width="100px"></el-table-column>
            <el-table-column label="动态" width="150px">
            <template slot-scope="scope">
              <div class="product-info">
                
                <div class="info">
                  <div class="namex" v-html="scope.row.context"></div>

                </div>
              </div>
            </template>
          </el-table-column>
            
 
            <!-- <el-table-column prop="type_text" label="动态类型"></el-table-column> -->
            <el-table-column prop="views" label="阅读量"></el-table-column>
            <el-table-column prop="fview" label="虚拟阅读量"></el-table-column>
            <el-table-column prop="likes" label="点赞数"></el-table-column>
            <el-table-column prop="flikes" label="虚拟点赞数"></el-table-column>
            <el-table-column prop="shares" label="分享数"></el-table-column>
            <el-table-column prop="fshares" label="虚拟分享数"></el-table-column>
            <el-table-column prop="is_featured" label="是否推荐"></el-table-column>
            <el-table-column prop="is_pinned" label="是否置顶"></el-table-column>
            <el-table-column prop="review_status" label="动态审核状态">
              <template slot-scope="scope">
                <div v-if="scope.row.review_status == 0">未审核</div>
                <div v-if="scope.row.review_status == 1">已通过</div>
                <div v-if="scope.row.review_status == 2">未通过</div>
              </template>

            </el-table-column>
            <el-table-column prop="status" label="上架/下架状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">已下架</div>
                <div v-if="scope.row.status == 1">上架中</div>
              </template>

            </el-table-column>
            <el-table-column prop="publish_time" label="发布时间"></el-table-column>
            <el-table-column prop="last_updated" label="最后更新时间"></el-table-column>
                </el-table>

                   <!--分页-->
            <div class="pagination">
              <el-pagination
              @size-change="handleSizeChange_bj"
              @current-change="handleCurrentChange_bj"
              background :current-page="curPage_bj"
              :page-sizes="[20, 100,500, 1000]"
              layout="total,sizes, prev, pager, next, jumper"
              :total="totalDataNumber_bj"></el-pagination>
            </div>



            <div class="common-form mt16" >登录记录</div>
                <el-table
                  :data="login_log"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    prop="time"
                    label="登录时间"
                    width="180"
                    sortable
                  >
                    <template slot-scope="scope">
                    {{ scope.row.login_time }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="ip_address"
                    label="IP地址"
                    width="150"
                  ></el-table-column>

                  <el-table-column
                    prop="location"
                    label="登录地点"
                  ></el-table-column>

                  <el-table-column
                    prop="device_type"
                    label="设备类型"
                  ></el-table-column>
                </el-table>

                   <!--分页-->
            <div class="pagination">
              <el-pagination
              @size-change="handleSizeChange_ll"
              @current-change="handleCurrentChange_ll"
              background :current-page="curPage_ll"
              :page-sizes="[20, 100,500, 1000]"
              layout="total,sizes, prev, pager, next, jumper"
              :total="totalDataNumber_ll"></el-pagination>
            </div>

          

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
        <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
        </Upload>
    </el-dialog>
</template>

<script>
        import UserApi from '@/api/user.js';
        import Upload from '@/components/file/Upload';
        export default {
        components: {
            /*图片上传*/
            Upload: Upload,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                /* 城市锁 */
                lock_city:true,
                /* 区域锁 */
                lock_region:true,
                province_options:{},
                city_options:{},
                region_options:{},
                password_val:'',
                password_val2:'',
                // 会员到期时间选择器左侧快捷选项
                timePickerOpt: {
                shortcuts: [{
                  text: '一年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 1)
                    picker.$emit('pick', date)
                  }
                }, {
                  text: '两年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 2)
                    picker.$emit('pick', date)
                  }
                }, {
                  text: '三年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 3)
                    picker.$emit('pick', date)
                  }
                }]
              },
              isProductUpload:false,
              rolearr:[],


              login_log:[],
              totalDataNumber_ll:0,
              /*当前是第几页*/
              curPage_ll: 1,
              /*一页多少条*/
              pageSize_ll: 20,


              biji:[],
              totalDataNumber_bj:0,
              /*当前是第几页*/
              curPage_bj: 1,
              /*一页多少条*/
              pageSize_bj: 20,

            };
        },
        props: ['open_add','form', 'gradeList'],
        created() {
            this.dialogVisible = this.open_add;
            this.getAddressList();
            this.getCustomer();
            this.getRole();
            this.getDetail();
        },
        methods: {
                   /*打开上传图片*/
           openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },
    getDetail(){
      var self = this;
      let Params ={}
      Params.user_id = self.form.user_id
      Params.curPage_ll = self.curPage_ll
      Params.pageSize_ll = self.pageSize_ll

      Params.curPage_bj = self.curPage_bj
      Params.pageSize_bj = self.pageSize_bj
      UserApi.detail(Params, true)
                    .then(data => {
                        self.login_log = data.data.login_log.data
                        self.totalDataNumber_ll = data.data.login_log.total


                        self.biji = data.data.biji.data
                        self.totalDataNumber_bj = data.data.biji.total
                    })
                    .catch(error => {

                    });
    },
       /*选择第几页*/
       handleCurrentChange_ll(val) {
      this.curPage_ll = val
      this.getDetail()
    },
    /*每页多少条*/
    handleSizeChange_ll(val) {
      this.curPage_ll = 1
      this.pageSize_ll = val
      this.getDetail()
    },

    /*上传商品图片*/
   returnProductImgsFunc(e) {

        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

          var avatarUrl = e[0].file_path;
          this.form.avatarUrl = avatarUrl;
          this.$set(this.form, "avatarUrl", avatarUrl);
      }
   
      
      this.isProductUpload = false;
    },

            getRole(){
                let self = this

                let Params = {}

                UserApi.getRole(Params, true)
                    .then(data => {
                        console.log('data.data',data.data)
                    self.rolearr = data.data
                    })
                    .catch(error => {

                    });
            },
            getCustomer(){
                let self = this;
                let Params = {}
                Params.user_id = self.form.user_id
                console.log(Params)
                UserApi.getCustomerData(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        let formInline = data.data.list;
                        if (formInline.province_id > 0){
                            self.lock_city = false
                            self.form.province_name = formInline.province_name
                            self.form.province_id = formInline.province_id
                            self.cityList(formInline.province_id)
                        }
                      //  self.cityList(formInline.province_id)
                        if (formInline.city_id > 0){
                            self.lock_region = false
                            self.form.city_name = formInline.city_name
                            self.form.city_id = formInline.city_id
                            self.form.region_name = formInline.region_name
                            self.form.region_id = formInline.region_id
                            self.regionList(formInline.city_id);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /* 省份获取 */
            getAddressList(){
                let self = this;
                UserApi.provinceList('',true)
                    .then(data => {
                        self.province_options = data.data.list;
                        console.log(self.province_options)
                    })
                    .catch(error => {

                    });
            },
            /* 市列表 */
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                UserApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            /* 区列表 */
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                UserApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            /* 选择省 */
            provinceChange(selVal){
                let self = this
                self.form.province_name = selVal.name
                self.form. province_id = selVal.id
                self.form.city_name = ""
                self.form.city_id = ""
                self.form.region_id = ""
                console.log(self.lock_city)
                self.lock_city = false
                console.log(self.lock_city)
                if (!self.lock_region){
                    self.lock_region = true
                    self.form.region_name = ""
                }
                self.cityList(selVal.id)
            },
            /* 选择市 */
            cityChange(selVal){
                let self = this
                self.form.city_name = selVal.name
                self.form.city_id = selVal.id
                self.form.region_name = ""
                self.form.region_id = ""
                if (self.lock_region){
                    self.lock_region = false
                }
                self.regionList(selVal.id);
            },
            /* 选择区 */
            regionChange(selVal){
                let self = this
                self.form.region_name = selVal.name
                self.form.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
                console.log(self.form.region_name)
            },


            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                if(self.password_val != ''){
                    if(self.password_val2 == ''){
                        self.$message({
                            message: '请确认新密码',
                            type: 'info'
                        });
                        self.loading = false;
                        return false;
                    }

                    if(self.password_val != self.password_val2){
                        self.$message({
                            message: '密码不一致',
                            type: 'info'
                        });
                        self.loading = false;
                        return false;
                    }

                    params.password = self.password_val
                }

                // 地区信息完善
                //用户地区信息改为非必填
                // if (params.city_id == undefined || params.city_id == ''){
                //     self.$message({
                //         message: '请完善用户地区信息',
                //         type: 'info'
                //     });
                //     self.loading = false;
                //     return false;
                // }
                // if (params.region_id == undefined || params.region_id == ''){
                //     self.$message({
                //         message: '请完善用户地区信息',
                //         type: 'info'
                //     });
                //     self.loading = false;
                //     return false;
                // }
                UserApi.editAdd(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '恭喜你，用户修改成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Detail.vue